import { HeadingPriority } from "atoms/constants/heading-priority";
import Heading from "atoms/typography/heading";
import PublicationCodeGroupRecord from "models/view-models/publication-code-group-record";
import PublicationRecord from "models/view-models/publication-record";
import UserPublicationPinRecord from "models/view-models/user-publication-pin-record";
import PublicationItem, {
    PublicationTextStyle,
} from "organisms/publication-lists/publication-item";
import PublicationList from "organisms/publication-lists/publication-list";
import React from "react";
import { CollectionUtils } from "utilities/collection-utils";
import { t } from "utilities/localization-utils";

const CSS_BASE_CLASS_NAME = "c-publication-list-search";

interface PublicationListSearchContentsProps {
    enableResults: boolean;
    publicationGroups: PublicationCodeGroupRecord[];
    publicationGroupsLoading: boolean;
    favoritedPublications: PublicationRecord[];
    observerRef: (node: any) => void;
    onPublicationClick: (publication: PublicationRecord) => void;
    pins?: UserPublicationPinRecord[];
    onChangePins: (pins: UserPublicationPinRecord[]) => void;
}

const PublicationListSearchContents = ({
    enableResults,
    publicationGroups,
    publicationGroupsLoading,
    observerRef,
    pins,
    onChangePins,
    onPublicationClick,
    favoritedPublications,
}: PublicationListSearchContentsProps) => {
    return (
        <>
            {enableResults ? (
                <PublicationList
                    publicationGroups={publicationGroups}
                    loading={publicationGroupsLoading}
                    observerRef={observerRef}
                    pins={pins}
                    onChangePins={onChangePins}
                    onPublicationClick={onPublicationClick}
                />
            ) : (
                CollectionUtils.hasValues(favoritedPublications) && (
                    <>
                        <Heading
                            cssClassName={`${CSS_BASE_CLASS_NAME}__favoritesHeading`}
                            priority={HeadingPriority.Five}>
                            {t("favoritePublications")}
                        </Heading>
                        {favoritedPublications.map((publication) => {
                            return (
                                <PublicationItem
                                    key={publication.id}
                                    publication={publication}
                                    style={PublicationTextStyle.TitleFirst}
                                    pins={pins}
                                    onChangePins={onChangePins}
                                    onPublicationClick={onPublicationClick}
                                />
                            );
                        })}
                    </>
                )
            )}
        </>
    );
};

export default PublicationListSearchContents;
